/**
 * ETKİNLİK SAYFASINDAN DAVET KARARI — İNVALİDASYON (B-15 · 09.10.2026).
 *
 * `invalidation.ts` dosya tavanına dayandığı için aile burada durur ve oraya
 * yayılır (`invalidation-org-account.ts` deseni); harita TEKTİR. Anahtarlar
 * dışarıdan verilir, bu dosya `invalidation.ts`i içe aktarmaz.
 *
 * - Kabul katılım kaydı yazar: dizin, yaka kartı ve SUNUCU sayfası bayatlar
 *   (`invite_only` sınırlı görünüm tam görünüme döner, sayaçlar artar).
 * - Ret yalnız kişinin kendi kulvarını değiştirir.
 */
export function myInvitationInvalidation(keys) {
    return {
        'participation/myInvitationAccept': [
            keys.myAttendance,
            keys.attendeeList,
            keys.eventDetail,
            keys.badge,
        ],
        'participation/myInvitationDecline': [keys.myAttendance],
    };
}
//# sourceMappingURL=invalidation-my-invitation.js.map